export const apiCreate = (): string => '/users/permissionsAssociated/create'
export const apiList = (id?: string): string =>
  !id
    ? '/users/permissionsAssociated/'
    : `/users/permissionsAssociated/view/${id}`
export const apiUpdate = (id: string): string =>
  `/users/permissionsAssociated/update/${id}`
export const apiDelete = (id: string): string =>
  `/users/permissionsAssociated/delete/${id}`
